import { render } from "./FormColour.vue?vue&type=template&id=bddab118"
import script from "./FormColour.vue?vue&type=script&lang=js"
export * from "./FormColour.vue?vue&type=script&lang=js"

import "./FormColour.vue?vue&type=style&index=0&id=bddab118&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__